import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import { GetSignatureAuditReportApi } from "../../../api/request/report";
import { Spin } from "antd";
import siteConfig from "../../../config";

const SignatureAuditModal = ({ isOpen, setIsOpen, selectedData }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const icons = {
    0: "document-create.svg",
    1: "email-send.svg",
    2: "email-check.svg",
    3: "document-sign.svg",
    4: "document-sign.svg",
    5: "check-circle.svg",
  };

  const getSignatureAuditReport = async () => {
    try {
      setIsLoading(true);
      const params = {
        document_id: selectedData?.id,
        user_id: selectedData?.user_id,
      };
      const { data } = await GetSignatureAuditReportApi(params);
      if (data?.status) {
        setData(data);
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedData?.id) getSignatureAuditReport();
  }, [selectedData]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Signature Audit Report"}
      width={800}
    >
      {isLoading ? (
        <div className="flex justify-center">
          <Spin className="size-[22px]" />
        </div>
      ) : (
        <div className="h-[500px] overflow-auto">
          <div className="flex justify-between items-end mb-5">
            <div>
              <p className="text-xl text-primary capitalize">
                {data?.document_name}
              </p>
              <p>Final Signature Audit Report</p>
            </div>
            <p>{data?.created_date}</p>
          </div>
          <div className="w-full p-5 bg-bgColor border-2 border-Gray mb-5 rounded-sm">
            <table>
              <tr>
                <td className="pe-5 font-semibold">Created :</td>
                <td>{data?.created_date}</td>
              </tr>
              <tr>
                <td className="pe-5 font-semibold">By :</td>
                <td>{siteConfig?.name}</td>
              </tr>
              <tr>
                <td className="pe-5 font-semibold">Status :</td>
                <td>{data?.signature_status}</td>
              </tr>
              <tr>
                <td className="pe-5 font-semibold">File Name :</td>
                <td className="capitalize">{data?.files?.service_name_slug}</td>
              </tr>
              <tr>
                <td className="pe-5 font-semibold">File Number :</td>
                <td>{data?.files?.file_number}</td>
              </tr>
            </table>
          </div>
          <div>
            <p className="text-xl font-semibold mb-3 capitalize">
              {data?.document_name} History
            </p>
            <div className="space-y-5">
              {data?.history?.map((item, index) => {
                return (
                  <div key={index} className="flex items-start gap-5">
                    <div className="mt-1">
                      <img
                        src={`/assets/icons/${icons[index]}`}
                        alt="icon"
                        className="size-5"
                      />
                    </div>
                    <div>
                      <p className="text-base font-medium">{item?.event}</p>
                      <p>{item?.timestamp}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </ModalComponent>
  );
};

export default SignatureAuditModal;
